export default __webpack_public_path__ + "static/media/classy-user.d79c6a52.png";